<!-- 講座画面タブメニュー -->
<script setup lang="ts">
  import { useDisplay } from "vuetify";
  import PlanTabMenuConfig from "~/consts/PlanTabMenuConfig";
  import { type ITabMenuItemInfo } from "~/interfaces/ITabMenuItemInfo";

  interface Emits {
    (event: "update:tab", tab: string): void;
  }

  interface Props {
    tab: string; // 選択されたタブのvalueが入る
    isOwner: boolean; // この講座のオーナーかどうか

    talkCount: number;
    talkEnabled: boolean;
    contentCount: number;
    contentEnabled: boolean;
  }
  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();
  const computedData = computed<string>({
    get: () => props.tab,
    set: value => {
      emit("update:tab", value);
    },
  });

  const menuItems = ref<ITabMenuItemInfo[]>([]);

  const createMenu = () => {
    menuItems.value = [];
    // それぞれの項目が有効であれば表示する
    if (props.talkEnabled) {
      menuItems.value.push({
        ...PlanTabMenuConfig.TALK,
        count: props.talkCount,
      });
    }
    if (props.contentEnabled) {
      menuItems.value.push({
        ...PlanTabMenuConfig.CONTENT,
        count: props.contentCount,
      });
    }
    if (props.isOwner) {
      // オーナーの場合はユーザーリストを表示する
      menuItems.value.push({
        ...PlanTabMenuConfig.MEMBER_LIST,
        count: 0,
      });
    }
    menuItems.value.push({
      ...PlanTabMenuConfig.OVERVIEW,
      count: 0,
    });
  };

  // メニュー作成
  createMenu();

  // 状態を監視
  watch(
    () => {
      return [props.isOwner, props.talkEnabled, props.talkCount, props.contentEnabled, props.contentCount];
    },
    () => {
      createMenu();
    },
    { immediate: true },
  );

  const { name } = useDisplay();
  const isSp = computed<boolean>(() => name.value === "xs");
</script>

<template>
  <OrganismsTabMenu v-model:tab="computedData" :items="menuItems" :vertical="isSp" />
</template>
